import { IntentType } from '@40seas/entities/intents';
import { useUser } from '@40seas/frontend/libs/hooks';
import { IntentCallbacks, navigationProvider } from '@40seas/payments-shared';
import { useInitStripe } from 'frontend/apps/dashboard/src/hooks/useInitStripe';
import { useAuth } from 'frontend/apps/dashboard/src/hooks/useAuth';
import { DashboardModalConfig } from '../../../../../../providers/modal/layoutStrategyProvider';
import { useIntentsModal } from '../../IntentsModal';

export const useCreateDashboardModal = () => {
    const initStripe = useInitStripe();
    const { openModal } = useIntentsModal();
    const { isAuthenticated } = useAuth();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const user = isAuthenticated ? useUser() : undefined;

    const signupIntents = [IntentType.SignupInvite, IntentType.Signup];

    return async ({ intentType, token, configurationOverrides }: DashboardModalConfig) => {
        await initStripe({ token });

        const callbacks: IntentCallbacks = {
            onConfirm:
                intentType === IntentType.Signup ||
                intentType === IntentType.SignupInvite ||
                intentType === IntentType.BuyerGuarantee ||
                intentType === IntentType.BuyerOwner
                    ? navigationProvider.navigationToDashboard
                    : () => {},
        };

        openModal({
            intentType,
            callbacks,
            isEmbedded: !signupIntents.includes(intentType),
            token,
            user,
            configurationOverrides,
        });
    };
};
